import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const contentService = {
  // Carousel işlemleri
  getCarouselImages: async () => {
    const response = await axios.get(`${API_URL}/contents/carousel`);
    return response.data;
  },

  uploadCarouselImage: async (formData) => {
    const response = await axios.post(`${API_URL}/contents/carousel`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  updateCarouselImage: async (id, formData) => {
    const response = await axios.put(`${API_URL}/contents/carousel/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  deleteCarouselImage: async (id) => {
    const response = await axios.delete(`${API_URL}/contents/carousel/${id}`);
    return response.data;
  },

  reorderCarousel: async (items) => {
    const response = await axios.put(`${API_URL}/contents/carousel/reorder`, { items });
    return response.data;
  }
};
